/**
 * Builds an image URL compatible with `@react-pdf/renderer`.
 * WebP is not supported natively — request JPEG via `format=jpeg` (Nest ImageController + sharp).
 */
export function convertImageUrlForPDF(
  imageUrl: string | null | undefined,
  options: { width?: number } = {}
): string {
  if (!imageUrl) {
    return '';
  }
  const { width } = options;
  const isWebPPath = /\.webp(\?|$)/i.test(imageUrl);
  if (!isWebPPath && width == null) {
    return imageUrl;
  }
  try {
    const isAbsolute = /^https?:\/\//i.test(imageUrl);
    const base =
      typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const url = isAbsolute ? new URL(imageUrl) : new URL(imageUrl, base);
    const isWebP =
      /\.webp$/i.test(url.pathname) ||
      url.searchParams.get('format')?.toLowerCase() === 'webp';
    if (isWebP) {
      url.searchParams.set('format', 'jpeg');
    }
    if (width != null) {
      url.searchParams.set('width', String(width));
    }
    if (isAbsolute) {
      return url.toString();
    }
    return `${url.pathname}${url.search}`;
  } catch {
    let result = imageUrl;
    if (isWebPPath) {
      const separator = result.includes('?') ? '&' : '?';
      result = `${result}${separator}format=jpeg`;
    }
    if (width != null) {
      const separator = result.includes('?') ? '&' : '?';
      result = `${result}${separator}width=${width}`;
    }
    return result;
  }
}
